
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/belanja-di-toko",
      function () {
        return require("private-next-pages/belanja-di-toko.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/belanja-di-toko"])
      });
    }
  